if (!customElements.get('collection-load-more')) {
  customElements.define(
    'collection-load-more',
    class CollectionLoadMore extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        if (!this.link) return;

        this.onClick = this.handleClick.bind(this);
        this.link.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.link && this.onClick) {
          this.link.removeEventListener('click', this.onClick);
        }
      }

      handleClick(event) {
        event.preventDefault();
        if (this.link.classList.contains('loading')) return;
        this.loadNextPage();
      }

      setStatus(message) {
        const status = document.querySelector('[data-load-more-status]');
        if (status) status.textContent = message || '';
      }

      async loadNextPage() {
        const grid = document.getElementById('product-grid');
        if (!grid || !grid.dataset.id) return;

        const nextUrl = new URL(this.link.href, window.location.origin);
        nextUrl.searchParams.set('section_id', grid.dataset.id);

        const status = document.querySelector('[data-load-more-status]');
        const spinner = this.querySelector('.loading__spinner');
        this.link.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
        this.link.setAttribute('aria-disabled', 'true');
        this.link.setAttribute(
          'aria-label',
          (status && status.dataset.loadingMessage) || this.link.textContent.trim()
        );
        grid.setAttribute('aria-busy', 'true');
        this.setStatus(status && status.dataset.loadingMessage);

        try {
          const response = await fetch(nextUrl.toString());
          if (!response.ok) throw new Error('Failed to load more products');

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = doc.getElementById('product-grid');
          if (!newGrid) throw new Error('No product grid in response');

          Array.from(newGrid.children).forEach((item) => {
            item.querySelectorAll('.scroll-trigger').forEach((element) => {
              element.classList.add('scroll-trigger--cancel');
            });
            if (item.classList.contains('scroll-trigger')) {
              item.classList.add('scroll-trigger--cancel');
            }
            grid.appendChild(item);
          });

          this.setStatus(status && status.dataset.loadedMessage);

          const newLoadMoreLink = doc.querySelector('collection-load-more a');
          if (newLoadMoreLink) {
            this.link.href = newLoadMoreLink.getAttribute('href');
          } else {
            this.remove();
          }
        } catch (error) {
          window.location.href = this.link.href;
        } finally {
          if (this.isConnected && this.link) {
            const spinner = this.querySelector('.loading__spinner');
            this.link.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            this.link.removeAttribute('aria-disabled');
            this.link.removeAttribute('aria-label');
          }
          grid.removeAttribute('aria-busy');
        }
      }
    }
  );
}

if (!customElements.get('collection-back-to-top')) {
  customElements.define(
    'collection-back-to-top',
    class CollectionBackToTop extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;

        this.onClick = this.handleClick.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.button && this.onClick) {
          this.button.removeEventListener('click', this.onClick);
        }
      }

      handleClick() {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const target = document.getElementById('CollectionTop');

        if (target) {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          target.focus({ preventScroll: true });
          return;
        }

        window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    }
  );
}
